import { mediaUrl } from "@/lib/api";
import { EntityManager } from "./EntityManager";

const fields = [
  { name: "name", label: "Nom complet", required: true },
  { name: "role", label: "Fonction", required: true },
  { name: "email", label: "E-mail" },
  { name: "order", label: "Ordre d'affichage", type: "number" },
  { name: "bio", label: "Biographie", type: "textarea", rows: 3, full: true },
  { name: "photo_url", label: "Photo", type: "file", accept: "image/*", placeholder: "Téléverser une photo", full: true },
];
const columns = [
  { key: "name", label: "Membre", render: (m) => <div className="flex items-center gap-3"><div className="w-10 h-10 bg-zinc-200 overflow-hidden shrink-0">{m.photo_url && <img src={mediaUrl(m.photo_url)} alt="" className="w-full h-full object-cover" />}</div><div><div className="font-semibold">{m.name}</div><div className="text-xs text-zinc-500">{m.role}</div></div></div> },
  { key: "email", label: "E-mail" },
  { key: "order", label: "Ordre" },
];

const DEFAULTS = { name: "", role: "", email: "", order: 0, bio: "", photo_url: "" };

export default function TeamManager() {
  return <EntityManager title="Équipe" description="Membres affichés sur la page À propos › Équipe." listUrl="/team" baseUrl="/team" fields={fields} columns={columns} testId="team" defaults={DEFAULTS} />;
}
